import getEpisodeEditFormSchema from '@app/organisms/EpisodeEditForm/schemas/episodeEditFormSchema';

const getSaveAndCloseSchema = (intl) => {
    const baseSchema = getEpisodeEditFormSchema(intl);

    return baseSchema.clone();
};

export default getSaveAndCloseSchema;
